const listPointsBody = document.querySelector('#filmAFConsider').querySelector('div[name=body]');
// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';
import tools from '../tools/tools.js';
import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index) {
    let urlImg = '';
    let groupClass = ' ';
    

    if(item.image){
      https://festcontent.ru/fests/actionMSK1/films/f-2_82d0.jpg
//
                            // <img src="https://festcontent.ru/fests/${auth.currentFestival}/img/films/${item}.jpg">
      urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/films/${tools.jsonStringToStringgetElementBy(item.image, 0)}.jpg`;
      // urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/films/${tools.jsonStringToString(item.image)}.jpg`;
    }
    else
      urlImg = '';


  return `<div class = "card_film_preview column p-1 ${groupClass}" fCID=${item.id} numReq=${item.id}> 
              <img  fCID=${item.id}   numReq=${item.id}  style = "width:auto;  min-height:100px;" src="${urlImg}" class="shimmer">
              <label fCID=${item.id}  numReq=${item.id} class="txt-al-center" >${item.name}</label>
          </div>`;
  },

  drawDataInContainer(enterprisesData) {
    this.cleanContainer();
    let HTMLBODY = '';
    if(enterprisesData) {
      listPointsBody.classList.remove('row');
      listPointsBody.classList.remove('column');
      listPointsBody.classList.add('row');
      
      enterprisesData.forEach((item, index) => {
   
        HTMLBODY += this.getElement(item, index);
      });
      listPointsBody.innerHTML = HTMLBODY;
    } else
      listPointsBody.innerHTML = 'Данных пока нет';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
